import React from 'react'
import LandlordLease from '../Components/Lease Agreement/LandlordLease'

const LandlordLeasePage = () => {
  return (
    <LandlordLease />
  )
}

export default LandlordLeasePage